<template>
  <div :style="styles" class="sideBarCard">
    <v-navigation-drawer
      v-model="drawer"
      :rail="!mobile"
      :expand-on-hover="!mobile"
      :temporary="mobile"
      class="navDrawerFixed"
      :class="mobile ? 'ml-0' : 'ml-1'"
      :color="colorDrawer"
    >
      <v-list nav v-if="!isTepeaca">
        <!-- DashBoard -->
        <v-list-item
          link
          v-for="(item, i) in dashboardItem"
          :key="i"
          :value="item.value"
          :title="item.title"
          class="nav_item_title"
          :prepend-icon="item.icon"
          @click="changeActive(true), changeView(item.value)"
          :active="dashActive"
        ></v-list-item>

        <span v-if="!isRAOS && !isLIMA">
          <v-list-group value="topology">
            <template v-slot:activator="{ props }">
              <v-list-item
                class="nav_item_title"
                v-bind="props"
                :title="t('sidebar.topology')"
                prepend-icon="mdi-state-machine"
              ></v-list-item>
            </template>
            <v-list-item
              link
              v-for="(item, key) in items"
              :key="key"
              class="nav_item_title"
              :title="item.title"
              :value="item.value"
              @click="changeActive(false), changeViewhash(item.value)"
            >
              <template v-slot:prepend>
                <div style="width: 36px">
                  <svg
                    class="iconDraw"
                    version="1.0"
                    xmlns="http://www.w3.org/2000/svg"
                    width="25px"
                    viewBox="0 0 300.000000 300.000000"
                  >
                    <g v-html="item.icon" />
                  </svg>
                </div>
              </template>
            </v-list-item>
          </v-list-group>
        </span>

        <v-list-group value="admin">
          <template v-slot:activator="{ props }">
            <v-list-item
              class="nav_item_title"
              v-bind="props"
              :title="t('sidebar.admin.title')"
              prepend-icon="mdi-file-cabinet"
            ></v-list-item>
          </template>

          <v-list-item
            v-for="(item, i) in admin"
            :key="i"
            :value="item.value"
            :title="item.title"
            class="nav_item_title"
            :prepend-icon="item.icon"
            @click="changeActive(false), changeView(item.value)"
          ></v-list-item>
        </v-list-group>

        <v-list-item
          v-for="(item, i) in kpi"
          :key="i"
          :value="item.value"
          :title="item.title"
          class="nav_item_title"
          :prepend-icon="item.icon"
          @click="changeActive(false), changeView(item.value)"
        ></v-list-item>

        <div v-if="!isRAOS">
          <v-list-item
            v-for="(item, i) in reportItems"
            :key="i"
            :value="item.value"
            :title="item.title"
            class="nav_item_title"
            :prepend-icon="item.icon"
            @click="changeActive(false), changeView(item.value)"
          ></v-list-item>
        </div>

        
          <v-list-item
            link
            v-for="(item, key) in drive"
            :key="key"
            class="nav_item_title"
            :prepend-icon="item.icon"
            :title="item.title"
            :value="item.value"
            @click="changeActive(false), changeView(item.value)"
          >
          </v-list-item>
          
          <v-list-item
            link
            v-for="(item, key) in servidores"
            :key="key"
            class="nav_item_title"
            :prepend-icon="item.icon"
            :title="item.title"
            :value="item.value"
            @click="changeActive(false), changeView(item.value)"
          >
          </v-list-item>

          <div v-if="isDEMO">
            <v-list-group value="GestorHCKlink">
              <template v-slot:activator="{ props }">
                <v-list-item
                  class="nav_item_title"
                  v-bind="props"
                  :title="'LTE/5G HCG-LINK'"
                  prepend-icon="mdi-state-machine"
                ></v-list-item>
              </template>
              <v-list-item
                link
                v-for="(item, key) in itemsGestor"
                :key="key"
                class="nav_item_title"
                :title="item.title"
                :value="item.value"
                :prepend-icon="item.icon"
                @click="changeActive(false), changeView(item.value)"
              >
              </v-list-item>
            </v-list-group>
          </div>

            <!-- <v-list-item
              link
              v-for="(item, key) in gestorTareas"
              :key="key"
              class="nav_item_title"
              :title="item.title"
              :value="item.value"
              :prepend-icon="item.icon"
              @click="changeActive(false), changeGTView()"
            >
            </v-list-item>

            <v-list-item
              link
              v-for="(item, key) in resetItems"
              :key="key"
              class="nav_item_title"
              :title="item.title"
              :value="item.value"
              :prepend-icon="item.icon"
              @click="changeActive(false), changeView(item.value)"
            >
            </v-list-item>
          </div> -->

        <!-- <v-list-item
          link
          v-for="(item,key) in energyItem"
          :key="key"
          class="nav_item_title"
          :title="item.title"
          :value="item.value" 
          :prepend-icon="item.icon" 
          @click="changeActive(false),changeView(item.value)"             
          >
          </v-list-item> -->
      </v-list>
      <v-list nav v-else>
        <v-list-item
          link
          v-for="(item, i) in finalTEPEOCA"
          :key="i"
          :value="item.value"
          :title="item.title"
          class="nav_item_title"
          :prepend-icon="item.icon"
          @click="changeActive(true), changeTepeacaView(item.value)"
        ></v-list-item>

      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import router from "@/router";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
const { mobile } = useDisplay();

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from "vue-i18n";
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
import { VISIBLE_PAGES, STRING_GENERAL, NAME_PROJECT } from "@/constants/labels";
import { COLORS_IN_HTML } from "@/constants/colors";
import CONSTANTSVG from "@/constants/svg";

/********************************
 ********** INTERFACES **********
 *******************************/
import { SIDEBAR } from "@/interfaces/SmartLink/Admin";

// let userROL = localStorage.getItem("rol");
// let finalRolUser = userROL ? parseInt(userROL) : 0;

const colorDrawer = computed(() => COLORS_IN_HTML.value.drawer);

const projectName = computed(() => store.state.projectName);
const isDEMO = computed(() => projectName.value === NAME_PROJECT.demo);
const isRAOS = computed(() => projectName.value === NAME_PROJECT.raos);
const isLIMA= computed(() => projectName.value === NAME_PROJECT.lima);
const isNacozari = computed(() => projectName.value === NAME_PROJECT.nacozari);
const isCollahuasi = computed(() => projectName.value === NAME_PROJECT.collahuasi);
const isCananea = computed(() => projectName.value === NAME_PROJECT.cananea);
const isTepeaca = computed(() => projectName.value === NAME_PROJECT.tepeaca);

const SIDEBAR_ITEMS: SIDEBAR = {
  DASHBOARD: isRAOS.value
    ? [
        {
          icon: "mdi-dump-truck",
          title: computed(() => t("sidebar.raos")),
          value: VISIBLE_PAGES.raospg,
        },
      ]
    : [
        {
          icon: "mdi-developer-board",
          title: computed(() => t("labels.dashboard")),
          value: VISIBLE_PAGES.dashboard,
        },
      ],
  FIRSTS: [
    {
      icon: CONSTANTSVG.pmpap,
      title: computed(() => t("labels.distribution")),
      value: STRING_GENERAL.distri,
    },
    {
      icon: CONSTANTSVG.solarTrailer,
      title: computed(() => t("labels.access")),
      value: STRING_GENERAL.access,
    },
    {
      icon: CONSTANTSVG.haultruck,
      title: computed(() => t("labels.client")),
      value: STRING_GENERAL.client,
    },
  ],
  ADMIN: [
    {
      icon: "mdi-tools",
      title: computed(() => t("sidebar.admin.admiInven")),
      value: VISIBLE_PAGES.management,
    },
    {
      icon: "mdi-file-excel",
      title: computed(() => t("sidebar.admin.admiCSV")),
      value: VISIBLE_PAGES.admincsv,
    },
  ],
  SERVIDORES: isCananea.value ? [
    {
      icon: "mdi-server",
      title: computed(() => t("sidebar.servers")),
      value: VISIBLE_PAGES.servers,
    },
    
  ] : [],
  REPORT: [
    {
      icon: "mdi-text-box-check",
      title: computed(() => t("sidebar.report")),
      value: VISIBLE_PAGES.report,
    },
  ],
  KPI: [
    {
      icon: "mdi-book-open-outline",
      title: computed(() => t("sidebar.kpi.general")),
      value: VISIBLE_PAGES.kpi,
    },
    {icon: 'mdi-video-input-antenna',   title:computed(() => t('sidebar.kpi.allLatency')),    value: VISIBLE_PAGES.allLatency, }
  ],
  IADISTRIBUTION: isDEMO.value
    ? [
        {
          icon: "mdi-chart-line",
          title: computed(() => t("sidebar.analytics.predicts")),
          value: VISIBLE_PAGES.predicts,
        },
      ]
    : [
        {
          icon: "mdi-chart-line",
          title: computed(() => t("sidebar.analytics.predicts")),
          value: VISIBLE_PAGES.predicts,
        },
        {
          icon: "mdi-stairs-up",
          title: computed(() => t("sidebar.analytics.predictsnr")),
          value: VISIBLE_PAGES.predictsnr,
        },
      ],
  DRIVE: !isNacozari.value && !isCollahuasi.value ? [

    {
      icon: "mdi-map-marker-path",
      title: computed(() => t("sidebar.driveHeatmap")),
      value: VISIBLE_PAGES.driveheatmap,
    },
    {
      icon: "mdi-arrow-decision",
      title: computed(() => t("sidebar.bandWidth")),
      value: VISIBLE_PAGES.bandWidth,
    },
    {
      icon: "mdi-car-wireless",
      title: computed(() => t("sidebar.visualMine")),
      value: VISIBLE_PAGES.driveClients,
    }
  ] : [
    {
      icon: "mdi-map-marker-path",
      title: computed(() => t("sidebar.driveHeatmap")),
      value: VISIBLE_PAGES.driveheatmap,
    },
    {
      icon: "mdi-arrow-decision",
      title: computed(() => t("sidebar.bandWidth")),
      value: VISIBLE_PAGES.bandWidth,
    }
  ]
  
  ,
  GESTORFIRST: [
    {
      icon: "mdi-monitor-dashboard",
      title: computed(() => 'dashboard Ejectivo'),
      value: VISIBLE_PAGES.gestorDash,
    },
    {
      icon: "mdi-cog",
      title: computed(() => t("labels.monitoring")),
      value: VISIBLE_PAGES.monitoring,
    },
    {
      icon: "mdi-file-eye",
      title: computed(() => t("labels.configuration")),
      value: VISIBLE_PAGES.config,
    },
    {
      icon: "mdi-chart-bell-curve-cumulative",
      title: computed(() => t("labels.statistics")),
      value: VISIBLE_PAGES.statistics,
    },
    // {
    //   icon: "mdi-chart-bell-curve-cumulative",
    //   title: computed(() => 'drive'),
    //   value: VISIBLE_PAGES.drive,
    // },
    // {
    //   icon: "mdi-chart-bell-curve-cumulative",
    //   title: computed(() => 'drive rajant'),
    //   value: VISIBLE_PAGES.driverajant,
    // },
  ],
  GESTORTAREAS: [
    {
      icon: "mdi-folder-star-multiple-outline",
      title: computed(() => t("labels.taskmanag")),
      value: "",
    },
  ],
  RESET: [
    {
      icon: "mdi-ballot-outline",
      title: computed(() => t("sidebar.reset")),
      value: VISIBLE_PAGES.reset,
    },
  ],
  ENERGY: [
    {
      icon: "mdi-lightning-bolt",
      title: computed(() => t("sidebar.energy")),
      value: VISIBLE_PAGES.energy,
    },
  ],
};
/**
 * Component
 */
const storeDrawer = computed(() => store.state.drawer);
const drawer = ref(true);
const temporary = ref(false);
const dashActive = ref(true);
const items = ref(SIDEBAR_ITEMS.FIRSTS);
const kpi = ref(SIDEBAR_ITEMS.KPI);
const admin = ref(SIDEBAR_ITEMS.ADMIN);
const reportItems = ref(SIDEBAR_ITEMS.REPORT);
const dashboardItem = ref(SIDEBAR_ITEMS.DASHBOARD);
const drive = ref(SIDEBAR_ITEMS.DRIVE);
const itemsGestor = ref(SIDEBAR_ITEMS.GESTORFIRST);
const servidores = ref(SIDEBAR_ITEMS.SERVIDORES)
const gestorTareas = ref(SIDEBAR_ITEMS.GESTORTAREAS);
const resetItems = ref(SIDEBAR_ITEMS.RESET);
// const energyItem = ref(SIDEBAR_ITEMS.ENERGY);





const TEPEOCA_DRAWER:SIDEBAR = {
  VIEWS:[
    {
      icon: "mdi-developer-board",
      title: computed(() => t("labels.dashboard")),
      value: VISIBLE_PAGES.tepeaca.dashboard,
    },
    // {
    //   icon: "mdi-book-open-outline",
    //   title: computed(() => t("sidebar.kpi.general")),
    //   value: VISIBLE_PAGES.tepeaca.kpi,
    // },
    {
      icon: "mdi-map-clock-outline",
      title: computed(() => 'Histórico'),
      value: VISIBLE_PAGES.tepeaca.playback,
    },
    {
      icon: "mdi-tools",
      title: computed(() => t("sidebar.admin.admiInven")),
      value: VISIBLE_PAGES.tepeaca.administracion,
    },
  ]
}

const finalTEPEOCA = ref(TEPEOCA_DRAWER.VIEWS)

//==================================================//
//===================== METHODS ====================//
//==================================================//

/**
 * Commit to Store to showView
 */

watch(storeDrawer, (b: boolean) => {
  drawer.value = b;
});

watch(drawer, (b: boolean) => {
  b ? store.commit("yesShowDrawer") : store.commit("noShowDrawer");
});

const showKPI = (value: string) => {
  store.commit("postKPIValue", value);
};

const changeActive = (isActive: boolean) => {
  dashActive.value = isActive;
};

const changeTepeacaView = (viewPage: string) => {
   router.push(`/smartlink/cemex/${viewPage}`);
};

const changeView = (viewPage: string) => {
  router.push(`/smartlink/${viewPage}`);
};

const changeGTView = () => {
  window.open("https://smartlink.hcgpe.com/GestorDeTareas", "_blank");
};

const changeViewhash = (viewPage: string) => {
  router.push(`/smartlink/topology#${viewPage}`);
};

onMounted(() => {
  if (mobile.value === true) store.commit("noShowDrawer");
});

/**
 * Son los estilos que mando desde el TS hacia el CSS, en este caso
 * los colores del scrollbar del drawer, cuando se expande demasiado
 */
const styles = computed(() => ({
  "--varColorDrawer": colorDrawer.value,
}));
</script>

<style>
.navDrawerFixed {
  position: fixed !important;
  /* border-top-right-radius: 10px; */
  border-radius: 10px;
  height: calc(100vh - 64px) !important;
  top: 64px !important;
}
.navDrawerFixed:hover {
  position: fixed !important;
  /* height: calc(100vh - 64px) !important;
  top: 64px !important; */
}

.nav_item_title {
  font-size: 14px !important;
  color: white;
}

.nav_item_title .v-list-item-title {
  font-weight: bold;
  text-transform: capitalize !important;
  font-size: 11px !important;
  font-family: "Poppins", sans-serif;
}

.nav_item_title .v-list-item-title {
  font-weight: bold;
  text-transform: capitalize !important;
}

.sideBarCard .v-list-group--prepend {
  --parent-padding: 0px !important;
}

.v-navigation-drawer--rail .v-navigation-drawer__content {
  overflow: hidden;
}

.v-navigation-drawer--is-hovering .v-navigation-drawer__content {
  overflow-y: visible !important;
}

.v-list-item__prepend > .v-icon ~ .v-list-item__spacer {
  width: 15px !important;
}

.navDrawerFixed .v-navigation-drawer__content::-webkit-scrollbar {
  width: 7.5px !important;
  background-color: var(--varColorDrawer) !important;
  border-top-right-radius: 20px;
}

@media print {
  .v-navigation-drawer {
    display: none !important;
    width: 0px !important;
  }
  .headerReport {
    display: none !important;
  }
  .home-styles {
    padding: 0px !important;
    background-color: white !important;
  }
  .v-toolbar {
    background-color: transparent !important;
  }
  .appBarComp {
    display: none !important;
  }
}
.iconMAP g {
  fill: white !important;
}
.iconDraw g {
  fill: white !important;
  margin-right: 20px !important;
}

/* .v-navigation-drawer {
  margin-left: 5px !important;
 }  */
</style>
